import React, { useEffect, useState } from 'react';
import { dealMgmt } from '../../services/dealManagementApi';
import { Badge, Card, CardHead, FilterBar } from '../../components/ui';
import { LoadingState, EmptyState, ErrorState } from '../../features/shared/PageStates';
import { formatDate, humanize } from '../../lib/format';

export function DocumentsPage({ onNavigate, showToast }) {
  const [docs, setDocs] = useState([]);
  const [q, setQ] = useState('');
  const [section, setSection] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => {
    setLoading(true);
    setError('');
    const params = {};
    if (q) params.q = q;
    if (section) params.section = section;
    dealMgmt.searchDocuments(params)
      .then(res => setDocs(res.documents || res.items || []))
      .catch(e => {
        setError(e.message);
        showToast?.(e.message, 'error');
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, section]);

  return (
    <div>
      <FilterBar>
        <input className="field-input" placeholder="Search documents…" value={q} onChange={e => setQ(e.target.value)} style={{ width: 240 }} />
        <select className="field-input" value={section} onChange={e => setSection(e.target.value)}>
          <option value="">All sections</option>
          <option value="stage_1">Stage 1</option>
          <option value="stage_2">Stage 2</option>
          <option value="contracting">Contracting</option>
          <option value="finance">Finance</option>
          <option value="delivery">Delivery</option>
        </select>
      </FilterBar>

      {loading && <LoadingState label="Searching documents…" />}
      {error && !loading && <ErrorState message={error} onRetry={load} />}
      {!loading && !error && docs.length === 0 && (
        <EmptyState title="No documents found" sub="Try another search or open a deal to upload docs." />
      )}
      {!loading && !error && docs.length > 0 && (
        <Card>
          <CardHead title="Documents" sub={`${docs.length} result(s)`} />
          <table className="tbl">
            <thead>
              <tr><th>Document</th><th>Deal</th><th>Section</th><th>Status</th><th>Updated</th></tr>
            </thead>
            <tbody>
              {docs.map(d => (
                <tr
                  key={d.id}
                  className="clickable"
                  onClick={() => d.deal_id && onNavigate('dm-deal-detail', { dmDealId: d.deal_id })}
                >
                  <td className="fw">{d.document_name || d.name}</td>
                  <td>{d.deal_ref || d.client_company_name || '—'}</td>
                  <td>{humanize(d.section)}</td>
                  <td><Badge type={d.status === 'uploaded' ? 'success' : 'neutral'}>{d.status || '—'}</Badge></td>
                  <td>{formatDate(d.updated_at || d.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}

export default DocumentsPage;
